import { render } from "./FlowsSpaceToggle.vue?vue&type=template&id=2e79e316"
import script from "./FlowsSpaceToggle.vue?vue&type=script&lang=js"
export * from "./FlowsSpaceToggle.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.29.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__